import React from 'react';

import logoSVG from '../../../public/logo.svg';

const Header = () => {
  return (
    <ul className="nav header">
      <li className="to-home">
        <a className="nav-link link navTo" href="/">
          <img src={logoSVG} alt="" />
        </a>
      </li>
      <li>
        <a
          className="nav-link link"
          href="https://ritzw.notion.site/About-Ritz-eb7871f95a494f40a8f9c73839690cf7?pvs=4"
          target="_blank"
        >
          About me
        </a>
      </li>
      <li>
        <a className="nav-link link" href="/Resume.pdf" target="_blank">
          Resume
        </a>
      </li>
      <li>
        <a
          className="nav-link link"
          href="https://www.linkedin.com/in/yufengritz"
        >
          LinkedIn
        </a>
      </li>
    </ul>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/Modules/Header/Header.jsx